import { SimpleTextFormat } from '@/components/element/SimpleTextFormat';

type Props = {
  modalId: string;
  okClicked: () => void;
  cancelClicked?: () => void;
  message: string;
};

export const ModalConfirm = ({ modalId, okClicked, cancelClicked, message }: Props) => {
  return (
    <div>
      <div className="modal fade" id={modalId} tabIndex={-1} role="dialog" aria-labelledby={modalId} aria-hidden="true">
        <div className="modal-dialog modal-danger modal-dialog-centered modal-" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-notification">
                Confirmation
              </h6>
              <button type="button" className="btn-close text-dark" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-3 text-center">
                <i className="fas fa-exclamation-circle ni-3x badge-warning bg-transparent"></i>
                <p className="mt-4 text-sm">
                  <SimpleTextFormat content={message} />
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn bg-gradient-secondary btn-sm"
                data-bs-dismiss="modal"
                onClick={() => {
                  cancelClicked && cancelClicked();
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn bg-gradient-primary btn-sm"
                data-bs-dismiss="modal"
                onClick={() => okClicked()}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
